export default __webpack_public_path__ + "static/media/cerealChoc.9c12b786.png";